import React from 'react'
import { clientOneData } from '../data'

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';

export default function ClientThree() {

    const settings = {
        container: '.tiny-three-item',
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 12,
        responsive: {
            992: {
                items: 3
            },

            767: {
                items: 2
            },

            320: {
                items: 1
            },
        },
      };

  return (
        <div className="tiny-three-item">  
            <TinySlider settings={settings}>
                {clientOneData.map((item,index)=>{
                    return(
                        <div className="tiny-slide" key={index}>
                            <div className="card review m-2 bg-white rounded border-0 shadow">
                                <div className="content position-relative overflow-hidden p-4">
                                    <ul className="list-unstyled h6 text-warning">
                                        <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                        <li className="list-inline-item"><i className="mdi mdi-star fs-6"></i></li>
                                    </ul>
                                    <p className="text-muted mb-0">{item.desc}</p>
                                    <h1 className="display-1 m-0"><i className="icons mdi mdi-format-quote-open"></i></h1>
                                </div>
                                <div className="reviewer d-flex p-4 border-top bg-light">
                                    <div className="text-center mt-1">
                                        <img src={item.image} className="img-fluid avatar avatar-ex-sm me-3 shadow rounded-pill" alt=""/>
                                    </div>
                                    <div>
                                        <h6 className="mb-0">{item.name}</h6>
                                        <p className="text-muted mb-0">{item.title}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </TinySlider>
        </div>
  )
}
